import { iDataProyectosResultadoMap } from "../../interfaces/UmmiaApps/iDataProyectosResultadoMap";

type Order = "asc" | "desc";

const toTime = (v: any) => {
  const t = new Date(v).getTime();
  return Number.isFinite(t) ? t : 0;
};

export const SortedDataPlanificaciones = (
  data: iDataProyectosResultadoMap[],
  orderBy?: string,
  order: Order = "desc"
) => {
  const key = orderBy?.trim() || "fechaCreacion";
  const dir = order === "asc" ? 1 : -1;

  return [...data].sort((a, b) => {
    // default: siempre fechaCreacion
    if (key === "fechaCreacion") {
      return (toTime(a.fechaCreacion) - toTime(b.fechaCreacion)) * dir;
    }

    if (key === "calificacion") {
      const av = Number((a as any).calificacion ?? 0);
      const bv = Number((b as any).calificacion ?? 0);
      return (av - bv) * dir;
    }

    if (key === "titulo" || key === "nivel" || key === "tipoEstructura") {
      const av = String((a as any)[key] ?? "");
      const bv = String((b as any)[key] ?? "");
      return av.localeCompare(bv, "es", { sensitivity: "base" }) * dir;
    }

    return (toTime(a.fechaCreacion) - toTime(b.fechaCreacion)) * dir;
  });
};
